import type { TemplatesListDataSource } from '../types'
import type { TableData } from '@app/types/table'
import type { ResponseDto } from '@app/api/dtos'
import type { TemplateDto } from '@app/api/routes/templates/dtos'

export const adaptTemplatesListTableData = (
  templateResponse: ResponseDto<TemplateDto>
): TableData<TemplatesListDataSource> => {
  const { count, results: template } = templateResponse

  const dataSource: TemplatesListDataSource[] = template.map(dto => ({
    key: dto.id,
    message: dto.message
  }))

  return { count, dataSource }
}
